import { useIdleTimer } from 'react-idle-timer';
import { generateToken } from '../api/authentication.api';
import idleTimerConfig from '../config';
import Utils from '../utils';
import { authenticationService } from '../services/authentication.service';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const useUserIdleTimer = (setAPIInterval, apiInterval) => {
  const navigate = useNavigate();
  const { idleTimer } = idleTimerConfig;

  const onIdle = () => {
    clearInterval(apiInterval);
    setAPIInterval('');
  };

  const onActive = () => {
    const callApi = async () => {
      try {
        const response = await generateToken();
        let decodedToken;

        try {
          decodedToken = jwtDecode(response?.data?.token);
        } catch (error) {
          console.error("Error decoding token:", error);
          return;
        }

        if (!response.success) {
          throw new Error('Network response was not ok');
        } else {
          // Utils.setLocalStorageItem('_t', response?.data?.token);
          const isOwner = decodedToken?.firstName === "owner";

          if (isOwner) {
            Utils.setLocalStorageItem("_proxy", response?.data?.token);
          } else {
            Utils.setLocalStorageItem("_t", response?.data?.token);
          }
        }
      } catch (error) {
        clearInterval(apiInterval);
        setAPIInterval('');
        // authenticationService.logout();
        console.error('Error calling API:', error);
        // navigate('/');
      }
    }

    setAPIInterval(
      setInterval(() => {
        const auth = Utils.getLocalStorageItem('_t');
        if (auth) {
          callApi();
        }
      }, idleTimer.SETINTERVALTIME)
    );
  };

  useIdleTimer({
    onIdle,
    onActive,
    timeout: 60000,
    crossTab: true,
    debounce: 500,
    leaderElection: true,
    syncTimers: 200,
  });
};

export default useUserIdleTimer;
